import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {AdminPanelService} from '../../data/admin-panel.service';
import {ActivityConditionBlock, ActivityForEdit} from '../../data/activityi-for-edit';
import {ActivityEditorDialogComponent} from './activity-editor-dialog/activity-editor-dialog.component';
import {UsersService} from '../../../users/data/users.service';
import {forkJoin} from 'rxjs';
import {UserRole} from 'projects/core/src/lib/login/data/user-role';
import {ProductionPlanningProjectsService} from '../../../production-planning/data/production-planning-projects.service';
import {ProductionPlanningPost} from '../../../production-planning/data/production-planning-post';
import {ProdPostEditorDialogComponent} from './prod-post-editor-dialog/prod-post-editor-dialog.component';

@Component({
  selector: 'app-activities-editor',
  templateUrl: './activities-editor.component.html',
  styleUrls: ['./activities-editor.component.scss']
})
export class ActivitiesEditorComponent implements OnInit {
  activities: ActivityForEdit[]
  activitiesMap = new Map<string, ActivityForEdit[]>();
  activitiesWithTitle: ActivityConditionBlock[] = []
  productionPosts: ProductionPlanningPost[] = []

  allRoles: UserRole[]

  loadingSpinner = true;

  constructor(
    private dialog: MatDialog,
    private usersService: UsersService,
    protected adminPanelService: AdminPanelService
  ) {
  }

  ngOnInit(): void {
    forkJoin([
      this.usersService.getRoles(),
      this.adminPanelService.getActivityConditions(),
      this.adminPanelService.getProductionPosts()
    ]).subscribe(res => {
      this.allRoles = res[0]
      this.activities = res[1]
      this.productionPosts = res[2]

      this.sortByClazz()
      this.loadingSpinner = false;
    })
  }

  sortByClazz() {
    this.activitiesMap.set('ACTIVITIES_CONDITION', [])

    this.activities.forEach(cond => {
      this.activitiesMap.get('ACTIVITIES_CONDITION').push(cond)
    })

    this.activitiesMap.forEach((val, key) => {
      this.activitiesWithTitle.push({
        title: this.adminPanelService.dictsMap.get(key),
        conditions: val
      })
    })
  }

  editActivity(activity: ActivityForEdit, index: number, jindex: number) {
    const dialogRef = this.dialog.open(ActivityEditorDialogComponent, {
      data: {
        activity,
        allRoles: this.allRoles
      },
      panelClass: 'activity-editor-dialog'
    });

    dialogRef.afterClosed().subscribe(newDict => {
      if (newDict && newDict instanceof ActivityForEdit) {
        this.activitiesWithTitle[index].conditions[jindex] = newDict
      }
    })
  }

  editPost(post: ProductionPlanningPost, index: number) {
    const dialogRef = this.dialog.open(ProdPostEditorDialogComponent, {
      data: {
        post
      },
      panelClass: 'prod-post-editor-dialog'
    });

    dialogRef.afterClosed().subscribe(newDict => {
      if (newDict && newDict instanceof ProductionPlanningPost) {
        this.productionPosts[index] = newDict
      }
    })
  }

}
